import { render, staticRenderFns } from "./AtencionAuditoriaVerComentarios.vue?vue&type=template&id=2f5fd600"
import script from "./AtencionAuditoriaVerComentarios.vue?vue&type=script&lang=js"
export * from "./AtencionAuditoriaVerComentarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports